import { useEffect, useState } from "react";
 import axios from "axios";


function useDishes(categoryID, listCategorys) {
    const LINK = "https://freedomkremenets.com/dishes/?ordering=-priority&category="
    const [data, setData] = useState([])

    useEffect(() => {
        if (categoryID !== undefined) {
            axios.get(LINK + categoryID)
            .then(res => {
                setData(res.data);
            }).catch(error => {
                console.log(error)
            });

        } else {

            axios.get('https://freedomkremenets.com/dishes/?category=&ordering=category')
            .then(res => {
                setData(res.data);
            }).catch(error => {
                console.log(error)
            });
        }
        

    }, [categoryID, listCategorys])

    return data
}

export default useDishes;
